export function normalizeReplayPathname(pathname) {
  const value = String(pathname || "").trim();
  if (!value) return "/";
  const withLeadingSlash = value.startsWith("/") ? value : `/${value}`;
  const normalized = withLeadingSlash
    .replace(/\/{2,}/g, "/")
    .replace(/\/+$/, "");
  return normalized || "/";
}

export function shouldRecordProductSession(pathname, isLinkedinQa = false) {
  // Production replay covers every route. Preserve the synthetic LinkedIn QA
  // override, which is also used in isolated automated tests.
  return (
    !isLinkedinQa ||
    normalizeReplayPathname(pathname).includes("/automation-center")
  );
}

export function getSessionReplayTransition(previous, next) {
  if (previous === next) return "none";
  return next ? "start" : "stop";
}
